import { useEffect } from "react";
import styled, { useTheme } from "styled-components";

const DURATION_MS = 4000;

const Wrap = styled.div`
  position: fixed;
  bottom: 1.5rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10000;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.6rem 1rem;
  font-family: "Silkscreen", monospace;
  font-size: 0.7rem;
  max-width: 90vw;
  box-shadow: 0 2px 12px ${({ theme }) => theme.colors("shadow", 0.4)};
`;

// Small self-dismissing toast for editor feedback (API errors, etc.)
// Controlled by the caller: pass `message` (null hides it) and `onDismiss`.
export const Toast = ({ message, kind = "error", onDismiss }) => {
  const { colors } = useTheme();

  useEffect(() => {
    if (!message) return;
    const t = setTimeout(onDismiss, DURATION_MS);
    return () => clearTimeout(t);
  }, [message, onDismiss]);

  if (!message) return null;

  const accent = kind === "error" ? colors("danger") : colors("highlight", 0.55);

  return (
    <Wrap
      style={{
        background: colors("chrome"),
        border: `1px solid ${accent}`,
        color: colors("highlight"),
      }}
    >
      <span>{message}</span>
      <span
        style={{ cursor: "pointer", opacity: 0.6, flexShrink: 0 }}
        onClick={onDismiss}
      >
        ✕
      </span>
    </Wrap>
  );
};
